import { inherits as _inherits, createClass as _createClass, defineProperty as _defineProperty, classCallCheck as _classCallCheck, callSuper as _callSuper } from '../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';

var Step = /*#__PURE__*/function (_React$Component) {
  function Step() {
    var _this;

    _classCallCheck(this, Step);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _callSuper(this, Step, [].concat(args));

    _defineProperty(_this, "goBackward", function () {
      if (_this.props.goBackward) {
        return _this.props.goBackward();
      }

      return true;
    });

    _defineProperty(_this, "goForward", function () {
      if (_this.props.goForward) {
        return _this.props.goForward();
      }

      return true;
    });

    return _this;
  }

  _inherits(Step, _React$Component);

  return _createClass(Step, [{
    key: "render",
    value: function render() {
      var content = /*#__PURE__*/React.cloneElement(this.props.children, this.props);
      return /*#__PURE__*/React.createElement("div", null, content);
    }
  }]);
}(React.Component);

_defineProperty(Step, "propTypes", {
  children: PropTypes.any,
  goBackward: PropTypes.func,
  goForward: PropTypes.func
});

Step.displayName = "Step";
export { Step };